import { useState } from "react";
import { appSubDir } from "../configs/app";

const ProgressiveImg: React.FC<any> = (props) => {
    const [imgUrl, setImgUrl] = useState(props.src)
    const defaultUrl = props.defaultUrl || appSubDir + "assets/img/image-not-found.webp"
    return <img {...props}
        referrerPolicy="no-referrer"
        loading='lazy'
        src={imgUrl}
        onError={() => {
            setImgUrl(defaultUrl)
        }} />
};

export default ProgressiveImg;
